export enum TableColumnKey {
  SettlementDate = 'settlementDate',
  DistributorAgentId = 'distributorAgentId',
  DistributorAgentName = 'distributorAgentName',
  PfhNo = 'pfhNo',
  ProgramName = 'programName',
  TotalTransactionAmount = 'totalTransactionAmount',
  Payment = 'payment',
  PaMarkup = 'paMarkup',
  VisaRebate = 'visaRebate',
  Repayment = 'repayment',
  AnnualFee = 'annualFee',
  PaRebate = 'paRebate',
  TotalAgentInterest = 'totalAgentInterest',
}

export interface TableRow {
  id: number;
  [TableColumnKey.SettlementDate]: string;
  [TableColumnKey.DistributorAgentId]: string;
  [TableColumnKey.DistributorAgentName]: string;
  [TableColumnKey.PfhNo]: string;
  [TableColumnKey.ProgramName]: string;
  [TableColumnKey.TotalTransactionAmount]: string;

  [TableColumnKey.Payment]: string;
  [TableColumnKey.Repayment]: string;
  [TableColumnKey.AnnualFee]: string;
  [TableColumnKey.PaMarkup]: string;
  [TableColumnKey.VisaRebate]: string;
  [TableColumnKey.PaRebate]: string;
  [TableColumnKey.TotalAgentInterest]: string;

  rawData: any;
}
